import { css } from '@portal/styled-system/css'

import { getAssetUrl } from '@/shared/lib/cdn'
import { useI18n } from '@/shared/lib/i18n'

export function KoreanAgeRatingBadge({ show = true }: { show?: boolean }) {
    const { lang } = useI18n()

    if (lang !== 'ko' || !show) {
        return null
    }

    return (
        <img
            src={getAssetUrl('/assets/korean_all_ages_rating_badge.svg')}
            alt="Rating"
            draggable="false"
            className={css({
                position: 'fixed',
                top: '[calc(var(--play-nav-height) + 12px)]',
                right: '[12px]',
                zIndex: 10,
                width: '[62px]',
                height: '[72px]',
                animation: '[fadeout 0.5s ease-out 3s forwards]',
                pointerEvents: 'none',
            })}
        />
    )
}
